import { defineStore } from "pinia";

export const useAbdullahStore = defineStore("abdullah", {
  state: () => {
    return {
      test: "Abdullah is awesome",
    };
  },

  //=========================== Getters ==============================
  getters: {
    getTest(state) {
      return state.test;
    },
  },
  //=========================== Actions ==============================

  actions: {
    edit(add) {
      test = add;
    },
  },
});
//=============================== How to Use ==========================
